import { Link } from "react-router-dom";

import { resolveRelationshipTarget } from "routes/custom_tables/relationshipRoutes";
import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

/**
 * Renders a relationship cell from the row's `<field_id>__display` sibling:
 * a live target links to its detail route (plain text when the target has
 * none), a soft-deleted target shows its label with a muted "(deleted)"
 * marker, and an unresolved id degrades to "#<id> (unavailable)".
 */
export default function RelationshipCell({ value, column, display }) {
  if (value == null || value === "") {
    return <span className="tw:text-muted-foreground">{EM_DASH}</span>;
  }
  if (!display || display.label == null) {
    return (
      <span className="tw:text-muted-foreground">#{value} (unavailable)</span>
    );
  }
  if (display.deleted) {
    return (
      <span className="tw:block tw:truncate">
        {display.label}{" "}
        <span className="tw:text-muted-foreground">(deleted)</span>
      </span>
    );
  }

  const target = resolveRelationshipTarget(
    column?.options?.target_type,
    column?.options
  );
  return target?.detailRoute ? (
    <Link
      to={target.detailRoute(value)}
      onClick={e => e.stopPropagation()}
      className="tw:block tw:truncate tw:text-[var(--color-blue)]! tw:hover:underline"
    >
      {display.label}
    </Link>
  ) : (
    <span className="tw:block tw:truncate">{display.label}</span>
  );
}
